export default __webpack_public_path__ + "static/media/trus22.7d9f0aaa.png";